/**
 * Release filenames, matching `ReleaseStore.kt` so both clients name the same
 * signed document the same way. The production's permissions tracker refers to
 * these names, so they are not cosmetic.
 */

export function surnameOf(signerName: string): string {
  const parts = signerName.trim().split(/\s+/)
  const last = parts.length ? parts[parts.length - 1] ?? '' : ''
  const cleaned = last.toUpperCase().replace(/[^A-Z0-9]/g, '')
  return cleaned || 'UNNAMED'
}

/** `RELEASE_SURNAME_YYYY-MM-DD`, with the date in the signer's own timezone. */
export function baseNameFor(signerName: string, date: Date): string {
  const yyyy = date.getFullYear()
  const mm = String(date.getMonth() + 1).padStart(2, '0')
  const dd = String(date.getDate()).padStart(2, '0')
  return `RELEASE_${surnameOf(signerName)}_${yyyy}-${mm}-${dd}`
}

/** Two signers with the same surname on the same day must not collide. */
export function disambiguate(base: string, taken: Set<string>): string {
  if (!taken.has(`${base}.pdf`)) return `${base}.pdf`
  let n = 2
  while (taken.has(`${base}_${n}.pdf`)) n++
  return `${base}_${n}.pdf`
}
